import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';

import {EmOperandIconComponent} from './operand-icon.component';
import {EmIconModule} from '@em/shared/ui';

@NgModule({
  imports: [CommonModule, EmIconModule],
  declarations: [EmOperandIconComponent],
  exports: [EmOperandIconComponent],
})
export class EmOperandIconModule {}
